import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../tailwind.css";

// React entry. Renders the single-page app into #root.
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found in index.html");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
